import { useMemo, useState } from 'react'
import { parseQueryString } from '../../../libs/historyHelper'

const fixedQuantityKey = 'fixed_qty'

export default function useItemQuantity(maxQuantity: number): {
  quantity: number
  setQuantity: (value: number) => void
  quantityFixed: boolean
} {
  const [quantity, setQuantity] = useState(1)
  const quantityFixed = useMemo(() => {
    const queryParams = parseQueryString()
    if (fixedQuantityKey in queryParams) {
      const fixedQuantityParam = queryParams[fixedQuantityKey]
      if (typeof fixedQuantityParam === 'string') {
        const fixedQuantity = parseInt(fixedQuantityParam, 10)
        if (
          !Number.isNaN(fixedQuantity) &&
          fixedQuantity >= 1 &&
          fixedQuantity <= maxQuantity
        ) {
          setQuantity(fixedQuantity)
          return true
        }
      }
    }
    return false
  }, [maxQuantity, setQuantity])

  return { quantity, setQuantity, quantityFixed }
}
